// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SearchKeyword_wrapper__27PyA","keyword":"SearchKeyword_keyword__3jxcC","button":"SearchKeyword_button__1UTV1"};